module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "html.worker.91abc3a7.js";